import { Owner } from 'api'
import React, { useState } from 'react'
import { ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap'

interface Props {
  selectedOwner?: Owner | null
  setSelectedOwner: (owner: Owner) => void
  owners: Owner[]
}

export const ControlPersonDropdown: React.FC<Props> = ({ selectedOwner, setSelectedOwner, owners }) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <ButtonDropdown isOpen={isOpen} toggle={() => setIsOpen(!isOpen)} className="mt-2 mb-2 rotessa-dropdown">
      <DropdownToggle caret className="btn-rotessa-secondary min-width">
        {selectedOwner ? (
          <span className="mr-1">
            {selectedOwner.firstName && selectedOwner.lastName
              ? `${selectedOwner.firstName} ${selectedOwner.lastName}`
              : selectedOwner.legalBusinessName}
          </span>
        ) : ( 
          'Select Control Person'
        )}
      </DropdownToggle>
      <DropdownMenu>
        {owners.map((owner) => (
          <DropdownItem key={owner.id} onClick={() => setSelectedOwner(owner)}>
            {owner.firstName && owner.lastName ? `${owner.firstName} ${owner.lastName}` : owner.legalBusinessName}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </ButtonDropdown>
  )
}
